import { createGlobalStyle } from 'styled-components';

// GlobalStyles component for application-wide styling
export const GlobalStyles = createGlobalStyle`
  /* Font definitions moved to public/fonts/vazirmatn.css for better caching */

  /* Apply font family based on language */
  html[lang="fa"] * {
    font-family: 'Vazirmatn', 'Tahoma', sans-serif !important;
  }

  html[lang="en"] * {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: #f0f2f5;
  }

  .app-container {
    min-height: 100vh;
  }

  .rtl {
    direction: rtl;
    text-align: right;
  }

  .ltr {
    direction: ltr;
    text-align: left;
  }

  /* Apply the theme styles */
  ${props => props.theme.styles}
`;

export default GlobalStyles;
